<template>
  <div class="alert-toast">
    <v-alert
      v-model="rootStore.toastShow"
      elevation="10"
      v-html="rootStore.toastText"
    >
    </v-alert>
  </div> 
</template>

<script setup lang="ts">
import { useRootStore } from '@/stores/useRootStore';

const rootStore = useRootStore();

</script>

<style lang="scss" scoped>
  .alert-toast {
    width: 100%;
    position: fixed;
    display: flex;
    justify-content: center;
    bottom: 2rem;
    z-index:100;
    font-size:var(--hecto-font-24);
    text-align: center;

    .v-alert {
      display: block;
      max-width: 85vw;
      background: #000;
      color: #fff;
      opacity: 0.6;
      border-radius: 6rem;
    }
  }
</style>